export { prepareHtmlForMathJax } from "@/lib/prepare-html-for-mathjax";

export const MATHJAX_CONFIG = {
	tex: {
		inlineMath: [
			["$", "$"],
			["\\(", "\\)"],
		],
		displayMath: [
			["$$", "$$"],
			["\\[", "\\]"],
		],
	},
	options: {
		skipHtmlTags: ["script", "noscript", "style", "textarea", "pre"],
		ignoreHtmlClass: "tex2jax_ignore",
	},
};

export {
	MathJax,
	MathJaxContext,
} from "better-react-mathjax";
